import cx from "classnames";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import styles from './CollapsibleTable.scss';

/**
 */
class CollapsibleTable extends PureComponent {
    static defaultProps = {
        className: undefined,
        collapsed: false
    };
    

    /**
     * @param {object} props
     */
    constructor(props) {
        super(props);
        this.state = {
            collapsed: props.collapsed
        };
    }

    handleCaptionClick = () => {
        this.setState(prevState => ({
            collapsed: !prevState.collapsed
        }));
    };

    /**
     * @return {*}
     */
    render = () => (
        <table className={cx([
            styles.CollapsibleTable, this.props.className, {[styles.collapsed]: this.state.collapsed}])}
        >
            <caption onClick={this.handleCaptionClick}>{this.props.caption}</caption>
            {this.props.children}
        </table>
    );
}
CollapsibleTable.propTypes = {
    className: PropTypes.string,
    caption: PropTypes.string.isRequired,
    collapsed: PropTypes.bool
};

export default CollapsibleTable;
